import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Giulia R.',
  location: 'Milano'
}, {
  name: 'Francesca M.',
  location: 'Roma'
}, {
  name: 'Chiara B.',
  location: 'Torino'
}, {
  name: 'Sara P.',
  location: 'Bologna'
}, {
  name: 'Martina L.',
  location: 'Firenze'
}, {
  name: 'Alessia F.',
  location: 'Napoli'
}, {
  name: 'Valentina C.',
  location: 'Verona'
}, {
  name: 'Elena G.',
  location: 'Genova'
}, {
  name: 'Marco T.',
  location: 'Padova'
}, {
  name: 'Federica S.',
  location: 'Bari'
}, {
  name: 'Laura V.',
  location: 'Palermo'
}, {
  name: 'Beatrice D.',
  location: 'Venezia'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 16000);
    const t = setTimeout(showPopup, 4000);
    return () => {
      clearInterval(interval);
      clearTimeout(t);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-185">
      <div className="bg-white border-2 border-brand-gold shadow-[0_0_22px_rgba(216,175,61,0.55)] rounded-lg p-2.5 pr-8 max-w-[290px] w-full relative overflow-hidden pointer-events-auto" data-id="element-186">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-gold via-brand-violet to-brand-gold" data-id="element-187"></div>

        <button onClick={() => setVisible(false)} aria-label="Chiudi" className="absolute top-1.5 right-1.5 text-brand-muted hover:text-brand-navy transition-colors" data-id="element-188">
          <XIcon className="w-4 h-4" data-id="element-189" />
        </button>

        <div className="flex items-center gap-3" data-id="element-190">
          <div className="w-10 h-10 rounded-full bg-brand-violet/10 flex items-center justify-center shrink-0 border border-brand-violet/30" data-id="element-191">
            <ShoppingBag className="w-5 h-5 text-brand-violet" data-id="element-192" />
          </div>
          <div className="leading-tight" data-id="element-193">
            <p className="font-heading font-bold text-brand-navy text-sm" data-id="element-194">
              {current.name}
            </p>
            <p className="text-[11px] text-brand-muted font-bold" data-id="element-195">
              da {current.location}, Italia
            </p>
            <p className="text-xs text-brand-violet font-extrabold mt-0.5" data-id="element-196">
              ha appena acquistato GINNASTICA PRO™
            </p>
          </div>
        </div>
      </div>
    </div>;
}